<template>
  <v-dialog v-model="dialog" persistent max-width="450" overlay-opacity="0.85" overlay-color="#050505">
    <div class="premium-card-wrapper">
      <div class="premium-card">
        <div class="background-glow"></div>

        <v-card class="content-card" dark elevation="0">
          <div class="card-header d-flex justify-space-between align-center pa-4">
            <v-chip x-small color="#3ca453" class="font-weight-black black--text px-3"> AB 05. JANUAR 2026 </v-chip>
            <v-icon small color="grey" @click="closeDialog">mdi-close</v-icon>
          </div>

          <v-card-text class="text-center pt-2 pb-6 relative-z">
            <h3 class="white--text text-h6 font-weight-black mb-2 text-uppercase">Aus roody wird well come FIT</h3>

            <p class="grey--text text--lighten-1 caption mb-8 px-2">
              Ab dem <span class="white--text font-weight-bold">05.01.2026</span> integrieren wir unsere App vollständig in die <br />
              <span class="white--text font-weight-bold">well come FIT Welt</span>.
            </p>

            <div class="transformation-stage mb-10">
              <div class="icon-box old">
                <div class="icon-inner">
                  <img src="/img/icons/apple-touch-icon-152x152.png" alt="Roody App" />
                </div>
                <span class="label">Bisher</span>
              </div>

              <div class="arrow-container">
                <v-icon color="#3ca453" class="arrow-anim">mdi-arrow-right-thin</v-icon>
              </div>

              <div class="icon-box new">
                <div class="glow-ring"></div>
                <div class="icon-inner">
                  <img src="/img/icons/app_icon.png" alt="well come FIT App" />
                </div>
                <span class="label highlight">Ab 05.01.26</span>
              </div>
            </div>

            <div class="features-box text-left mx-auto mb-8">
              <div class="feature-item mb-3">
                <v-icon color="#3ca453" size="20" class="mr-3">mdi-check-decagram</v-icon>
                <div>
                  <div class="white--text font-weight-bold body-2">Neuer Name & Look</div>
                  <div class="grey--text caption" style="line-height: 1.2">Aus Roody wird well come FIT. Damit du uns im Store sofort erkennst.</div>
                </div>
              </div>

              <div class="feature-item">
                <v-icon color="#3ca453" size="20" class="mr-3">mdi-view-dashboard-edit</v-icon>
                <div>
                  <div class="white--text font-weight-bold body-2">Smarter Homescreen</div>
                  <div class="grey--text caption" style="line-height: 1.2">
                    Abos, Infos und Trainingszeit jetzt noch schneller und einfacher im Zugriff.
                  </div>
                </div>
              </div>
            </div>

            <v-btn block large class="action-btn white--text font-weight-black" @click="closeDialog"> Alles klar!</v-btn>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "RebrandingInfo",
  data() {
    return {
      dialog: false,
    }
  },
  mounted() {
    const STORAGE_KEY = "rebranding_seen_date"
    const lastSeen = localStorage.getItem(STORAGE_KEY)
    const today = new Date().toDateString()

    // Dialog initial false lassen
    // Zeigen, wenn noch nie gesehen ODER das Datum nicht heute ist
    if (lastSeen !== today) {
      setTimeout(() => {
        this.dialog = true
      }, 1000)
    }
  },
  methods: {
    closeDialog() {
      const STORAGE_KEY = "rebranding_seen_date"
      const today = new Date().toDateString()
      localStorage.setItem(STORAGE_KEY, today)
      this.dialog = false
    },
  },
}
</script>

<style lang="scss" scoped>
// Hier dein bestehendes CSS einfügen (habe ich unverändert gelassen, da es gut aussieht)
// ... (Siehe oben im Original) ...
$wcf-green: #3ca453;
$card-bg: #1e1e1e;

.premium-card-wrapper {
  border-radius: 24px;
  overflow-x: hidden;
  max-height: 65vh;
}

.premium-card {
  position: relative;
  padding: 2px;
  background: linear-gradient(145deg, rgba(60, 164, 83, 0.6), rgba(30, 30, 30, 1) 50%);
}

.content-card {
  background: #141414 !important;
  border-radius: 22px !important;
  position: relative;
  z-index: 2;
}

.background-glow {
  position: absolute;
  top: -60px;
  right: -60px;
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, rgba($wcf-green, 0.15) 0%, rgba(0, 0, 0, 0) 70%);
  z-index: 1;
  pointer-events: none;
}

.relative-z {
  position: relative;
  z-index: 2;
}

.transformation-stage {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.icon-box {
  display: flex;
  flex-direction: column;
  align-items: center;

  .icon-inner {
    width: 65px;
    height: 65px;
    border-radius: 14px;
    background: #222;
    overflow: hidden;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .label {
    font-size: 10px;
    text-transform: uppercase;
    font-weight: bold;
    color: #666;
    letter-spacing: 1px;
  }

  &.old {
    transform: scale(0.9);
  }

  &.new {
    position: relative;
    .icon-inner {
      width: 90px;
      height: 90px;
      border: 2px solid rgba($wcf-green, 0.5);
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
      background: #000;
    }
    .label {
      color: $wcf-green;
      margin-top: 4px;
    }

    .glow-ring {
      position: absolute;
      top: 45px;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: 100%;
      border-radius: 18px;
      border: 2px solid $wcf-green;
      animation: pulse-ring 2.5s infinite;
      z-index: -1;
    }
  }
}

.arrow-container {
  opacity: 0.5;
  margin-top: -15px;
}
.arrow-anim {
  animation: slide-right 1.5s infinite ease-in-out;
}

.features-box {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  padding: 16px;
  max-width: 90%;
}

.feature-item {
  display: flex;
  align-items: flex-start;
}

.action-btn {
  border-radius: 50px;
  background: linear-gradient(90deg, $wcf-green 0%, darken($wcf-green, 10%) 100%);
  box-shadow: 0 5px 20px rgba($wcf-green, 0.3);
  letter-spacing: 1px;
  font-size: 0.9rem !important;
}

@keyframes pulse-ring {
  0% {
    width: 90px;
    height: 90px;
    opacity: 0.8;
  }
  100% {
    width: 140px;
    height: 140px;
    opacity: 0;
  }
}

@keyframes slide-right {
  0%,
  100% {
    transform: translateX(-3px);
    opacity: 0.3;
  }
  50% {
    transform: translateX(3px);
    opacity: 1;
  }
}
</style>
